"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DojoGaugeIncrementMethod = void 0;
/**
 * Gauge increment method, performing rounding with each note that is hit.
 */
class DojoGaugeIncrementMethod {
    constructor(id) {
        this._name = id;
    }
    static fromName(name, strict = true) {
        const item = DojoGaugeIncrementMethod._values.find((it) => it._name === name);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid gauge increment method: ${name}`);
        }
    }
    static fromRaw(raw, strict = true) {
        return DojoGaugeIncrementMethod.fromName(raw, strict);
    }
    toString() {
        return this._name;
    }
}
exports.DojoGaugeIncrementMethod = DojoGaugeIncrementMethod;
/**
 * Default calculation method, which delays the gauge from appearing at the
 * beginning.
 */
DojoGaugeIncrementMethod.Normal = new DojoGaugeIncrementMethod('Normal');
/**
 * Round towards negative infinity.
 */
DojoGaugeIncrementMethod.Floor = new DojoGaugeIncrementMethod('Floor');
/**
 * Round towards nearest whole.
 */
DojoGaugeIncrementMethod.Round = new DojoGaugeIncrementMethod('Round');
/**
 * Do not perform rounding.
 */
DojoGaugeIncrementMethod.Notfix = new DojoGaugeIncrementMethod('Notfix');
/**
 * Round towards positive infinity, the gauge appears to fill with the first
 * note.
 */
DojoGaugeIncrementMethod.Ceiling = new DojoGaugeIncrementMethod('Ceiling');
DojoGaugeIncrementMethod._values = [
    DojoGaugeIncrementMethod.Normal,
    DojoGaugeIncrementMethod.Floor,
    DojoGaugeIncrementMethod.Round,
    DojoGaugeIncrementMethod.Notfix,
    DojoGaugeIncrementMethod.Ceiling,
];
